import React from 'react';
import { ProfileHistory } from '../components/ui/ProfileHistory';

type ProfileHistoryScreen = {
    screenName: string;
    screenKey: string;
};

export const ProfileHistoryScreen: React.FC<ProfileHistoryScreen> = () => {
    return (
        <>
            <ProfileHistory />
        </>
    );
};
